import { useEffect, useRef, useState } from "react";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Dropdown } from "primereact/dropdown";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import AdminService from "../../../../service/AdminService";
import localeText from "../../../../locale";
import { Dialog } from "primereact/dialog";
import { useToggle } from "../../../../hooks/useToggle";
import "./styles.css";
import { formatDate } from "../../../../utilities/formatDate";

const filterUserType = (userType) => {
  switch (userType.toLowerCase()) {
    case "area manager":
      return "Manager";
    case "business partner":
      return "Partner";
    default:
      return "";
  }
};

// const changeTextOfDocumentNumber = (userType) => {
//   switch (userType.toLowerCase()) {
//     case "area manager":
//       return localeText("documentNumberPJ");
//     case "business partner":
//       return localeText("documentNumber");
//     default:
//       return "";
//   }
// };

const LisUserAddress = () => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [userType, setUserType] = useState({});
  const [usersType, setUsersType] = useState([]);
  const [showUserOptions, setShowUserOptions] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showAddressOptions, setShowAddressOptions] = useState(false);
  const [showRegisterButton, setShowRegisterButton] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [expression, setExpression] = useState("");

  const [usersList, setUsersList] = useState([]);
  const [userMoreInfo, setUserMoreInfo] = useState();
  const { setAsTrue, setAsFalse, value } = useToggle();

  const getUserInfoService = new GetUserInfoService();
  const adminService = new AdminService();

  const toast = useRef(null);
  const onSearch = async (searchedUser) => {
    await getUser(userType);
    let filteredUser = [...users];

    if (!!searchedUser) {
      filteredUser = users.filter((user) => user.label.includes(searchedUser));
      setUsers(filteredUser);
    }
  };

  const formartAddressList = (listAddress) => {
    const listArrays = listAddress.map((listedAddress) => ({
      label: `${listedAddress.street}, ${listedAddress.house_number}. ${listedAddress.city}, ${listedAddress.country_state}, ${listedAddress.country}.`,
      id: listedAddress.id,
    }));

    setAddresses(listArrays);
  };

  const getUser = async (userType) => {
    let response;
    switch (userType.label) {
      case "Managers":
        response = await adminService.getAreaManagers(localStorage.getItem("__extraconomy_token"));
        break;
      case "Sellers":
        response = await adminService.getSellers(localStorage.getItem("__extraconomy_token"));
        break;
      default:
        response = await adminService.getBusinessPartners(
          localStorage.getItem("__extraconomy_token")
        );
        break;
    }

    const { userListJSONs } = response.result;
    setUsersList(userListJSONs);
    const userDropdownList = userListJSONs.map((user) => {
      const {
        email,
        firstname,
        surname,
        username,
        address,
        number,
        district,
        city,
        postalCode,
        state,
        country,
      } = user;

      return {
        label: `${username}: ${email} - ${firstname} ${surname} - ${
          address ? `${address}, ` : ""
        } ${number ? `${number}, ` : ""} ${district ? `${district}, ` : ""} ${
          city ? `${city}, ` : ""
        } ${state ? `${state}, ` : ""} ${country ? `${country}, ` : ""} ${
          postalCode ? `${postalCode}` : ""
        }`,
        id: username,
        email: email,
      };
    });

    setUsers(userDropdownList);
    setShowUserOptions(true);
  };
  async function postLinkUserToAdress() {
    if (Object.keys(selectedAddress).length === 0) {
      toast.current.show({
        severity: "error",
        summary: localeText("chooseAddress"),
      });

      return;
    }

    if (selectedUser === "") {
      toast.current.show({
        severity: "error",
        summary: localeText("chooseUser"),
      });

      return;
    }

    try {
      setLoading(true);
      const res = await getUserInfoService.postLinkUserToAdress(
        localStorage.getItem("__extraconomy_token"),
        selectedAddress.id,
        selectedUser.id
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
        });
        setLoading(false);
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoading(false);
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    const userTypesArray = [{ label: "Managers" }, { label: "Partners" }, { label: "Sellers" }];

    setUsersType(userTypesArray);

    async function fetchData() {
      try {
        setLoading(true);

        const res = await getUserInfoService.getAdressInfo(
          localStorage.getItem("__extraconomy_token")
        );

        const addressArray = res.result.sender_addresses;

        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          formartAddressList(addressArray);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //documentNumberPJ documentNumber
  return (
    <>
      <Dialog
        header={localeText("userInfo")}
        visible={value}
        className="userAdress-modal mx-2"
        onHide={setAsFalse}
      >
        <p>{`${localeText("adminBackofficeName")}: ${userMoreInfo?.firstname} ${
          userMoreInfo?.surname
        }`}</p>
        {userMoreInfo?.username && <p>{`Username: ${userMoreInfo.username}`}</p>}
        {/* {userMoreInfo?.documentNumber && (
          <p>{`${changeTextOfDocumentNumber(userMoreInfo?.usertype)}: ${
            userMoreInfo.documentNumber
          }`}</p>
        )} */}
        {userMoreInfo?.email && <p>{`Email: ${userMoreInfo.email}`}</p>}
        {userMoreInfo?.phonenumber && (
          <p>{`${localeText("adminBackofficePhoneNumber")}: ${userMoreInfo.phonenumber}`}</p>
        )}
        {userMoreInfo?.usertype && (
          <p>{`${localeText("adminBackofficeUserType")}: ${filterUserType(
            userMoreInfo.usertype
          )}`}</p>
        )}
        {userMoreInfo?.dateCreation && (
          <p>{`${localeText("adminBackofficeDateCreation")}: ${formatDate(
            userMoreInfo.dateCreation
          )}`}</p>
        )}
        {userMoreInfo?.originRegister && (
          <p>{`${localeText("adminBackofficeOriginRegister")}: ${userMoreInfo.originRegister}`}</p>
        )}
        {userMoreInfo?.postalCode && (
          <p>{`${localeText("adminBackofficePostalCode")}: ${userMoreInfo.postalCode}`}</p>
        )}
        {userMoreInfo?.address && (
          <p>{`${localeText("adminBackofficeAddress")}: ${userMoreInfo.address}`}</p>
        )}
        {userMoreInfo?.number && (
          <p>{`${localeText("adminBackofficeNumber")}: ${userMoreInfo.number}`}</p>
        )}
        {userMoreInfo?.city && (
          <p>{`${localeText("adminBackofficeCity")}: ${userMoreInfo.city}`}</p>
        )}
        {userMoreInfo?.district && (
          <p>{`${localeText("adminBackofficeDistrict")}: ${userMoreInfo.district}`}</p>
        )}
        {userMoreInfo?.state && (
          <p>{`${localeText("adminBackofficeState")}: ${userMoreInfo.state}`}</p>
        )}
        {userMoreInfo?.country && (
          <p>{`${localeText("adminBackofficeCountry")}: ${userMoreInfo.country}`}</p>
        )}
        {userMoreInfo?.complement && (
          <p>{`${localeText("adminBackofficeComplement")}: ${userMoreInfo.complement}`}</p>
        )}
      </Dialog>

      <div className="card border-1 border-300">
        <Toast ref={toast} />
        <div className="border-round" style={{ backgroundColor: "#46a748" }}>
          <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
            {localeText("address")}
          </h1>
        </div>

        <hr />
        <div className="mb-5">
          <label>{localeText("userType")}</label>
          <Dropdown
            className="text-center w-full my-2"
            value={userType}
            options={usersType}
            onChange={(e) => {
              setUserType(e.value);
              getUser(e.value);
            }}
            style={{ minWidth: "108px" }}
          />
          {showUserOptions && (
            <>
              <div className="h-8rem flex flex-column justify-content-center align-content-center">
                <div className="px-4 w-full md:w-30rem relative mx-auto">
                  <InputText
                    value={expression}
                    onChange={(e) => setExpression(e.target.value)}
                    placeholder={localeText("searchUser")}
                    className="w-full font-light p-3 border-1 border-300 text-lg"
                    style={{ borderRadius: "1rem" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onSearch(expression);
                    }}
                  />
                  <Button
                    className="absolute"
                    icon={<i className="pi pi-search text-xl"></i>}
                    style={{ color: "#46a748", top: 13, right: 30 }}
                    rounded
                    text
                    onClick={() => onSearch(expression)}
                    loading={loading}
                  />
                </div>
              </div>
              <label>{localeText("user")}</label>
              <Dropdown
                className="text-center w-full my-2"
                value={selectedUser}
                options={users}
                onChange={(e) => {
                  setShowMessage(true);
                  setSelectedUser(e.value);
                  setUserMoreInfo(usersList.find((user) => user.email === e.value.email));
                }}
                style={{ minWidth: "108px" }}
              />
            </>
          )}
          {showMessage && (
            <div className="d-flex align-items-end flex-column w-100 col-12">
              <div className="col-12 mb-2">
                <label>{localeText("UserAddressOnSendCloud")}</label>
              </div>
              <Button
                label={localeText("yes")}
                loading={loading}
                className="mr-2 w-full lg:w-auto md:w-auto m-1"
                onClick={() => setShowAddressOptions(true)}
              />
              <Button
                label={localeText("register")}
                loading={loading}
                className="mr-2 w-full lg:w-auto md:w-auto m-1 p-button-warning"
                onClick={() =>
                  window.open(
                    "https://account.sendcloud.com/login/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
              <Button
                label={localeText("userInfo")}
                className="mr-2 w-full lg:w-auto md:w-auto m-1 bg-indigo-800 hover:bg-indigo-900 border-indigo-800 hover:border-indigo-900"
                onClick={setAsTrue}
              />
            </div>
          )}
          {showAddressOptions && (
            <>
              <label>{localeText("address")}</label>
              <Dropdown
                className="text-center w-full my-2"
                value={selectedAddress}
                options={addresses}
                onChange={(e) => {
                  setShowRegisterButton(true);
                  setSelectedAddress(e.value);
                }}
                style={{ minWidth: "108px" }}
              />
            </>
          )}
        </div>
        {showRegisterButton && (
          <div className="d-flex align-items-end flex-column">
            <Button
              label={localeText("registerBrand")}
              loading={loading}
              className="mr-2 w-full lg:w-auto md:w-auto m-1"
              onClick={() => postLinkUserToAdress(true)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LisUserAddress;
